/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * Rounds a number to a specified precision
 * @param value - The number to round
 * @param precision - The number of decimal places to round to (default: 2)
 * @returns The rounded number, or 0 for invalid inputs
 * @example
 * roundValueToPrecision(3.14159, 2) // Returns 3.14
 * roundValueToPrecision(NaN) // Returns 0
 */

function getDecimalPrecision(num: number) {
  const decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

export function roundValueToPrecision(value: number, precision: number) {
  // Handle invalid input cases
  if (typeof value !== 'number' || isNaN(value) || !Number.isFinite(value)) {
    return 0;
  }

  const nearest = Math.round(value / precision) * precision;
  return Number(nearest.toFixed(getDecimalPrecision(precision)));
}
